import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  userProcessFetchUserProcess: null,
  userProcessFetchUserProcessLoading: ['boolean'],
  userProcessFetchUserProcessSuccess: ['process']
});

export const UserProcessTypes = Types;
export default Creators;
